import { UserModel } from "../domaine/userModel";

export const persistToken = (token: string): void => {
  localStorage.setItem("accessToken", token);
};

export const readToken = (): string => {
  return localStorage.getItem("accessToken") || "";
};

export const persistUser = (user: UserModel): void => {
  localStorage.setItem("user", JSON.stringify(user));
};

export const readUser = (): UserModel | null => {
  const userStr = localStorage.getItem("user");

  return userStr ? JSON.parse(userStr) : null;
};

export const persistProjectID = (projectID: number): void => {
  localStorage.setItem("projectID", projectID.toString());
};

export const readProjectID = (): number | null => {
  const projectID = localStorage.getItem("projectID");
  return projectID ? parseInt(projectID, 10) : null;
};

export const deleteToken = (): void => localStorage.removeItem("accessToken");
export const deleteUser = (): void => localStorage.removeItem("user");
export const deleteProjectID = (): void => localStorage.removeItem("projectID");
